import React from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';

/**
 * @param {string} birthDateValue ISO date string of birth
 * @returns {string} Age in years formatted in Spanish or dash when invalid
 */
function getAgeText(birthDateValue) {
  if (!birthDateValue) return '-';
  const birthMoment = moment(birthDateValue);
  if (!birthMoment.isValid()) return '-';
  if (birthMoment.isAfter(moment())) return '-';
  const ageYears = moment().diff(birthMoment, 'years');
  return `${ageYears} ${ageYears === 1 ? 'año' : 'años'}`;
}

export default function PrincipalData({
  location = '-',
  birthDate,
  dni = 0,
  address = '-',
  country = '-',
  region = '-',
  phone = 0,
  phoneAlt = 0,
  email = '-',
  currentJob = '-',
  fatherName,
  fatherLastName,
  isRollingKid,
  onCollapsePanel = () => {},
}) {
  const phoneDisplay = `${phone} ${phoneAlt ? `/ ${phoneAlt}` : ''}`;
  const fatherDisplay =
    fatherName || fatherLastName
      ? `${fatherName || ''} ${fatherLastName || ''}`.trim()
      : '-';

  return (
    <div className="sd-card w-100">
      <div className="sd-panel-head">
        <div>
          <h3 className="sd-section-title">Datos principales</h3>
          <p className="sd-section-sub">Contacto e identidad del alumno</p>
        </div>
        <Button
          variant="outline-secondary"
          size="sm"
          className="sd-hide-btn"
          onClick={onCollapsePanel}
          title="Ocultar panel"
        >
          <FontAwesomeIcon icon={faEyeSlash} />
        </Button>
      </div>
      <div className="mt-2">
        <div className="sd-field">
          <span className="sd-label">Fecha de nacimiento</span>
          <span className="sd-value">
            {birthDate ? moment(birthDate).format('ll') : '-'}
          </span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Edad</span>
          <span className="sd-value">{getAgeText(birthDate)}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">D.N.I.</span>
          <span className="sd-value">{dni}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Dirección</span>
          <span className="sd-value">{address}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">País</span>
          <span className="sd-value">{country}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Provincia</span>
          <span className="sd-value">{region}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Localidad</span>
          <span className="sd-value">{location}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Teléfono</span>
          <span className="sd-value">{phoneDisplay}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">E-mail</span>
          <span className="sd-value" style={{ wordBreak: 'break-all' }}>
            {email}
          </span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Ocupación</span>
          <span className="sd-value">{currentJob}</span>
        </div>
        {isRollingKid && (
          <>
            <div className="mt-2">
              <span className="sd-pill sd-pill-kid">Es Rolling Kid</span>
            </div>
            <div className="sd-field">
              <span className="sd-label">Datos del padre</span>
              <span className="sd-value">{fatherDisplay}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
